import { render, staticRenderFns } from "./singleWithBlock.vue?vue&type=template&id=141c80ca&scoped=true"
import script from "./singleWithBlock.vue?vue&type=script&lang=js"
export * from "./singleWithBlock.vue?vue&type=script&lang=js"
import style0 from "./singleWithBlock.vue?vue&type=style&index=0&id=141c80ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c80ca",
  null
  
)

export default component.exports